const state = {
  token: null,
  exp: null
};

const mutations = {
  login: (state, payload) => {
    state.token = payload.token;
    state.exp = new Date().getTime() / 1000 + 3600 * 24 * 30 * 365;
  },
  logout: state => {
    state.token = null;
    state.exp = new Date().getTime() / 1000;
    localStorage.clear();
  }
};

const actions = {
  login({ commit }, payload) {
    commit("login", payload);
  },
  logout({ commit }) {
    commit("logout");
  }
};

const getters = {
  authenticated: state => {
    return state.token !== null && state.exp >= new Date().getTime() / 1000;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
